import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, Form } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { AppComponent } from '../../app.component';
import { user } from './user';
import Swal from 'sweetalert2';
declare const myTest: any;

import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  public users;

  public mediaData: Array<any> = [

  ]
  registerForm: FormGroup;
  usercode: string = "";
  EmailID: string = "";
  password: string = "";
  termCondition: string = "";
  masters: any;
  master: any;
  url: string;
  data1: any;
  cssUrl: string;
  output: string;
  showErr: boolean;
  errorMsg: string;
  loading: boolean;
  CheckSass: boolean;
  SysNav0: [];
  SysNav1: [];
  loginForm: FormGroup;
  forgotPasswordForm: FormGroup;
  showSignup = false;
  baseUrl = AppComponent.baseURL;
  showMsg: boolean;
  Msg: string;
  status: number;
  class: string;
  showPassword: boolean = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    public sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.url = AppComponent.baseURL;
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      acceptTerms: [false]
    });

    this.forgotPasswordForm = this.fb.group({
      code: [''],
      userName: [''],
      email: ['', [Validators.email, Validators.required]],
    });

  }

  ngOnInit() {
    this.loading = false;
    let element: HTMLElement;
    element = document.getElementsByClassName('modal-backdrop')[0] as HTMLElement;
    if (element != null) {
      element.remove();
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  toggleForm() {
    this.showSignup = !this.showSignup;
  }

  onLoginSubmit() {
    if (!this.loginForm.value.acceptTerms) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid input',
        text: 'Please accept terms & conditions',
      })
      return;
    }

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const { email, password } = this.loginForm.value;
    this.loading = true;

    this.http
      .get<user>(`${this.baseUrl}Login/login`, {
        params: { EmailID: email, Password: password }
      })
      .subscribe({
        next: (res) => {
          this.loading = false;
          if (!res || (res.Status !== 200 && res.Status !== 404)) {
            Swal.fire({
              icon: 'error',
              title: 'Login Failed',
              text: res.Message || 'An error occurred during login. Please try again.',
            })
            return;
          }

          // Store session details
          localStorage.setItem('xVal', res.xVal);
          localStorage.setItem('LoginUserID', res.UserID.toString());
          localStorage.setItem('LoginID', res.UserID.toString());
          localStorage.setItem('UserName', res.UserName.toString());
          localStorage.setItem('Role', res.Role.toString());
          localStorage.setItem('UserRight', res.UserRight);
          localStorage.setItem('Users', res.NoOfUser.toString());
          localStorage.setItem('Logo', res.logo);
          localStorage.setItem('Company', res.NoOfCompany.toString());
          localStorage.setItem('CommunityRights', res.CommunityRights.toString());
          localStorage.setItem('CommunityCode', '');
          localStorage.setItem('email', email)
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/dashboard']);
          });
        },
        error: () => {
          this.loading = false;
          this.toastr.error('Internal Server Error', 'Login Failed');
        }
      });
  }

  onForgotPasswordSubmit() {
    if (this.forgotPasswordForm.value.email == '' && this.forgotPasswordForm.value.userName == '' && this.forgotPasswordForm.value.code == '') {
      // alert('Please provide email or user name and code.');
      return;
    }
    this.http.get(
      this.baseUrl + 'Login/RecoverPassword?EmailID=' + this.forgotPasswordForm.value.email)
      .subscribe((data: any) => {
        this.Msg = data.Message;
        this.showMsg = true;
        this.status = data.Status;
        if (data.Status != 200) {
          this.class = "Err";
        } else {
          this.class = "";
        }
      },
        (error) => {
          console.error('Error during password recovery:', error);
          this.Msg = error.error.Message;
          this.showMsg = true;
        }
      );
  }
}
